export default __webpack_public_path__ + "static/media/Pro-4a.5abb8afc.png";